import { ServicesProvider, sessionAtom, TrackingController } from '@capsicum/common';
import { useAtomValue } from 'jotai/react';
import { type ReactNode, useEffect, useState } from 'react';

import { GoogleAnalyticsTracking } from '../../services/tracking/google-analytics-tracking.service';
import { SegmentTracking } from '../../services/tracking/segment-tracking.service';
import { WebAdjustTracking } from '../../services/tracking/web-adjust-tracking.service';
import { env } from '../../util/env';

export const WebServicesProvider = ({ children }: { children: ReactNode }) => {
	const userId = useAtomValue(sessionAtom)?.userId;
	const [analyticsController, setAnalyticsController] = useState<null | TrackingController>(null);

	useEffect(() => {
		const environment = env.NEXT_PUBLIC_ENV || 'integration';

		const controller = new TrackingController(
			new SegmentTracking(environment, userId),
			new WebAdjustTracking(userId),
			new GoogleAnalyticsTracking()
		);

		setAnalyticsController(controller);
	}, [userId]);

	if (!analyticsController) {
		return null;
	}

	return <ServicesProvider analyticsController={analyticsController}>{children}</ServicesProvider>;
};
